export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * [send_to_email description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @param  {[type]} email           [description]
     * @return {[type]}                 [description]
     */
    send_to_email({commit, getters}, email) {
      return this._vm.$http.get('otp/send-via-email?email='+email)
        .then(response => response.data)
    },
    /**
     * [send_to_mobile description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @param  {[type]} mobile          [description]
     * @return {[type]}                 [description]
     */
    send_to_mobile({commit, getters}, mobile) {
      return this._vm.$http.get('otp/send-via-mobile?mobile='+mobile)
        .then(response => response.data)
    },
    /**
     * [verify_code description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @param  {[type]} code            [description]
     * @return {[type]}                 [description]
     */
    verify_code({commit, getters}, {code, hash}) {
      return this._vm.$http.post('otp/verify', {code, hash})
        .then(response => response.data)
    }
  }
}